import * as React from "react";
import { observer } from "mobx-react";
import { getUniqueClassName, createBsUtilMsgItem } from "../../../../helpers";
import { BetBtn } from "../BetBtn";
export const BetButtonsWrap = observer((props) => {
    const marketUniqueClass = getUniqueClassName(props.market.id, "market");
    const selections = props.market.selections;
    return (React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__section rj-ev-list__${props.componentPrefix}__section--${props.market.template} ${marketUniqueClass}`, "data-uat": `div-ev-list-${props.componentPrefix}-section` }, selections.map((s, index) => {
        const selectionUniqueClass = getUniqueClassName(s.id, "selection");
        const betslipModifier = s.isSelectionInBetslip
            ? "rj-ev-list__bet-btn--chosen"
            : "";
        return (React.createElement(BetBtn, { key: `${props.componentPrefix}__bet-btn__${index}`, isDisabled: s.isDisabled, hideLowOdds: props.details.hideLowOdds, classNames: `${betslipModifier} ${selectionUniqueClass}`, handler: () => props.details.handlers.betButton(s.isSelectionInBetslip, [createBsUtilMsgItem(props.details.event, props.market, s)]), text: s.name, point: s.pointsText, odd: s.odds, trueOdds: s.trueOdds }));
    })));
});
//# sourceMappingURL=BetButtonsWrap.js.map